import React from "react";
import './OOTD.css';

const events = [
    { time: '1:00 PM', title: 'Arrival', iconUrl: '../icons/Arrival.jpeg' },
    { time: '1:15 PM', title: 'Seated for Ceremony', iconUrl: '../icons/seats.jpeg' },
    { time: '1:30 PM', title: 'Ceremony', iconUrl: '../icons/ring2.jpeg'},
    { time: '2:15 PM', title: 'Drinks Reception + Canapes', iconUrl: '../icons/drinksRecption.jpeg' },
    { time: '4:30 PM', title: 'Wedding Breakfast', iconUrl: '../icons/weddingBreakfast.jpeg' },
    { time: '5:30 PM', title: 'Dessert', iconUrl: '../icons/dessert.jpeg' },
    { time: '5:45 PM', title: 'Speeches', iconUrl: '../icons/speech.jpeg' },
    { time: '6:30 PM', title: 'Games', iconUrl: '../icons/games.jpeg' },
    { time: '9:00 PM', title: 'Evening food', iconUrl: '../icons/burger.jpeg' },
    { time: '12:00 AM', title: 'Carriages (Departure)', iconUrl: '../icons/carriage.jpeg' },
];

const TimelineItem = ({ event, index }) => {
    const isLeft = index % 2 === 0;
    const itemClasses = `timeline-item mb-5 position-relative w-50 ${isLeft ? 'start-0 pe-5' : 'start-50 ps-5'}`;
    const iconContainerClasses = `timeline-icon position-absolute top-0 d-flex align-items-center justify-content-center overflow-hidden ${isLeft ? 'timeline-icon-left' : 'timeline-icon-right'}`; // Added overflow-hidden
    const textContainerClasses = `text-content position-relative d-inline-block bg-white rounded shadow-sm p-3 ${isLeft ? 'text-end ms-auto' : 'text-start'}`;

    return (
        <div className={`${itemClasses} ${isLeft ? 'text-end' : 'text-start'}`}>
            <div className={textContainerClasses}>
                <p className="fs-5 fw-semibold text-dark mb-1">{event.time}</p>
                <p className="small text-muted mb-0">{event.title}</p>
            </div>
            <div className={iconContainerClasses}>
                {event.iconUrl ? (
                    <img
                        src={event.iconUrl}
                        alt={event.title}
                        className="timeline-img rounded"
                    />
                ) : (
                    <span className="text-muted small">?</span>
                )}
            </div>
        </div>
    );
};


const Timeline = ({ events }) => {
    return (
        <div className="timeline-container position-relative mx-auto pb-4">
            {events.map((event, index) => (
                <TimelineItem key={index} event={event} index={index} />
            ))}
        </div>
    );
};

const OOTD = () => {
    return (
        <div class="ootd text-center container-styling">
            <div class="title-padding top-header">
                <h1>Order of the day</h1>
            </div>
            <div className="container py-5">
                <Timeline events={events} />
            </div>
    </div>
    );
}

export default OOTD;